import React, { useEffect } from 'react';
import { useDispatch, connect } from 'react-redux';
import { setNextPage } from '../../../redux/slices/appStateSlice';

const PartnerDetailsLogic = ({ fields, othersToAdd }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (othersToAdd.children) {
      dispatch(setNextPage(fields.childNextPage?.value?.href));
      return;
    }
    dispatch(setNextPage(fields.contactDetailsPage?.value?.href));
  }, [fields, othersToAdd]);

  return <></>;
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    othersToAdd: state.appState?.othersToAdd,
  };
};
export default connect(mapStateToProps)(PartnerDetailsLogic);
